import { render, staticRenderFns } from "./GridAreas.vue?vue&type=template&id=657d33a5&"
import script from "./GridAreas.vue?vue&type=script&lang=js&"
export * from "./GridAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GridAreas.vue"
export default component.exports